import { render } from "./ModalForm.vue?vue&type=template&id=5020a982&ts=true"
import script from "./ModalForm.vue?vue&type=script&lang=ts"
export * from "./ModalForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__